export default "__VITE_ASSET__b24a092c__"